"use client";

import React from "react";
import { ArrowRight, BookOpen, ChartLine, TrendingUp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WarmUpGuideHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return;
}